module.exports = __webpack_public_path__ + "static/img/Healing-10.8d31e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Healing Moment/Healing-10.jpg
// module id = 4o0L
// module chunks = 7